export class Appconstants {
    static readonly Yes: string = 'Yes';
    static readonly No: string = 'No';
    static readonly CUSTOMERCALLERTYPE: string = 'CUSTOMER';
    static readonly PASSERBYCALLERTYPE: string = 'PASSER BY';
    static readonly OTHERCALLERTYPE: string = 'OTHER';
}
